import auth from 'src/router/middleware/authentification/auth.js'

const NotificationCentre = () => import('src/views/NotificationCentre/NotificationCentre.vue')

export default [
  {
    path: '/notification-centre',
    name: 'notification-centre',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.notification_centre'
    },
    component: NotificationCentre
  }
]
